import { actions } from "@grandvisionhq/state";
const pushEvent = actions.action("analytics/data-layer/push-event", function(payload) {
  return { payload };
});
export {
  pushEvent
};
//# sourceMappingURL=actions.js.map
